import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import ProjectsSection from "@/components/ProjectsSection";
import FinalCta from "@/components/FinalCta";
import { API_URL } from "@/lib/api";
import { GALLERY } from "@/lib/gallery";

export default function ProjectsPage() {
  const [projects, setProjects] = useState(null);
  useEffect(() => {
    fetch(`${API_URL}/projects`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => setProjects((d && d.projects) || []))
      .catch(() => setProjects([]));
  }, []);
  return (
    <>
      <Seo
        title="Projects | Solar Black Belt"
        description="Verified completed commercial solar and storage work by Coastal Energy — a photo gallery of real installations. Verified case studies with measured results are published only with customer permission."
      />
      <section className="page-hero">
        <div className="wrap">
          <span className="eyebrow">REAL PROJECTS. REAL RESULTS.</span>
          <h1 data-testid="projects-heading">Jobs we've done.</h1>
          <p className="lead">
            A gallery of real commercial solar and storage work performed by Coastal Energy. Verified written case
            studies — with system capacity, dates and measured results — are published only for projects whose
            records are confirmed and whose customers gave permission.
          </p>
        </div>
      </section>
      <section style={{ paddingBottom: 50 }}>
        <div className="wrap">
          {projects && !projects.length && (
            <div className="panel" data-testid="projects-empty" style={{ marginBottom: 30 }}>
              <h3 style={{ fontSize: 18 }}>First verified case studies are in preparation.</h3>
              <p className="muted" style={{ fontSize: 13, margin: "10px 0" }}>
                We publish case studies only when project records (location, property type, system capacity with
                AC/DC identified, install date) are confirmed and the customer approves. Until then, this page shows
                our real work photos — and you can request references directly: call{" "}
                <a href="tel:+13108815155">310-881-5155</a> or ask during your assessment.
              </p>
            </div>
          )}
          {projects && projects.length > 3 && <ProjectsSection />}
          {projects && projects.length > 0 && projects.length <= 3 && null}
          <div className="section-heading" style={{ marginTop: 26 }}>
            <div>
              <span className="eyebrow">FROM THE FIELD</span>
              <h2>Photos from real job sites.</h2>
            </div>
            <p>More than a hundred photos from our completed installs — no stock imagery.</p>
          </div>
          <div className="field-strip" data-testid="projects-gallery-strip">
            {[29, 72, 8, 80, 58, 17, 87, 3].map((i) => {
              const img = GALLERY[i];
              return (
                <Link to="/gallery" key={img.src} className="field-item" aria-label={`View photo: ${img.alt}`}>
                  <img src={img.thumb} alt={img.alt} loading="lazy" width={400} height={400} style={{ aspectRatio: `${img.w} / ${img.h}` }} />
                </Link>
              );
            })}
          </div>
          <Link className="btn" to="/gallery" data-testid="projects-gallery-cta" style={{ marginTop: 16 }}>Open the full gallery <span>↗</span></Link>
        </div>
      </section>
      <FinalCta title={["Your building could be", "the next case study."]} service="commercial" context="Quote request" />
    </>
  );
}
